import objectPath from 'object-path'
import { compareTwoValue } from 'designer/component/action/Data'

const getTabParamValue = (tabParamActive = {}, conditionField = '') => {
  let [tabKey, paramName] = conditionField.split('.')
  let tabParamList = objectPath.get(tabParamActive, tabKey) || []
  let param = tabParamList.find((param) => param.name === paramName)
  return param?.value
}

const getActiveTabCondition = ({
  condition = {},
  designContext = {},
  isUiChanged = {},
}) => {
  let { value, tabKey } = condition
  let { jsonForm = {}, getCurrentUi = () => ({}) } = designContext
  let tabUi = getCurrentUi(value, jsonForm.schema, jsonForm.uischema)
  if (tabUi.key === value) {
    let tabName = tabUi.name
    return objectPath.get(isUiChanged, ['activeTab', tabKey]) === tabName
  }
  return false
}

const getConditionValue = ({
  condition = {},
  column = {},
  rowData = {},
  formData = {},
  datasourceValue = {},
  tabParamActive = {},
}) => {
  let { conditionCategory = 'table', conditionField } = condition
  if (conditionCategory === 'datasource') {
    return objectPath.get(datasourceValue, conditionField)
  }
  if (conditionCategory === 'element') {
    return objectPath.get(formData, conditionField)
  }
  if (conditionCategory === 'tabParam') {
    return getTabParamValue(tabParamActive, conditionField)
  }
  return objectPath.get(rowData, conditionField || column.field)
}

const getCompareValue = ({
  condition = {},
  formData = {},
  datasourceValue = {},
  tabParamActive = {},
}) => {
  let { value, valueCategory = 'rowValue' } = condition
  if (valueCategory === 'element') {
    return objectPath.get(formData, value)
  }
  if (valueCategory === 'datasource') {
    return objectPath.get(datasourceValue, value)
  }
  if (valueCategory === 'tabParam') {
    return getTabParamValue(tabParamActive, value)
  }
  return value
}

export const checkTableColumnCondition = ({
  condition = {},
  column = {},
  rowData = {},
  formData,
  datasourceValue,
  tabParamActive,
  designContext = {},
  isUiChanged,
}) => {
  let valueType = condition.valueType || 'equalValue'
  formData = formData || objectPath.get(designContext, 'jsonForm.formData') || {}
  datasourceValue =
    datasourceValue || objectPath.get(designContext, '@datasource') || {}
  tabParamActive =
    tabParamActive || objectPath.get(designContext, 'tabParamActive') || {}
  isUiChanged = isUiChanged || objectPath.get(designContext, 'isUiChanged') || {}

  if (valueType === 'tab') {
    return getActiveTabCondition({
      condition,
      designContext,
      isUiChanged,
    })
  }

  let conditionValue = getConditionValue({
    condition,
    column,
    rowData,
    formData,
    datasourceValue,
    tabParamActive,
  })
  let compareValue = getCompareValue({
    condition,
    formData,
    datasourceValue,
    tabParamActive,
  })

  return compareTwoValue(valueType, conditionValue, compareValue)
}
